import urls from '../api_urls/coowner'
import { _post } from '@/axios/request'
export function getOwnerGroup (params) {
  return _post(urls.getOwnerGroup, params)
}

export function updateOwnerGroup (params) {
  return _post(urls.updateOwnerGroup, params)
}

// 获取列表
export function getTableData (params) {
  return _post(urls.getList, params)
}

// 删除
export function deleteItem (params) {
  return _post(urls.delete, params)
}

// 获取详情
export function find (params) {
  return _post(urls.find, params)
}

// 新增
export function save (params) {
  return _post(urls.save, params)
}

// 编辑
export function update (params) {
  return _post(urls.update, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/coowner.js